export function getEye(zoom){
    if(zoom === 1){
        return "2500 km"
    }
    if(zoom === 2){
        return "2500 km"
    }
    if(zoom === 3){
        return "2500 km"
    }
    if(zoom === 4){
        return "1000 km"
    }
    if(zoom === 5){
        return "500 km"
    }
    if(zoom === 6){
        return "250 km"
    }
    if(zoom === 7){
        return "200 km"
    }
    if(zoom === 8){
        return "100 km"
    }
    if(zoom === 9){
        return "50 km"
    }
    if(zoom === 10){
        return "25 km"
    }
    if(zoom === 11){
        return "10 km"
    }
    if(zoom === 12){
        return "5 km"
    }
    if(zoom === 13){
        return "2 km"
    }
    if(zoom === 14){
        return "1 km"
    }
    if(zoom === 15){
        return "500 m"
    }
    if(zoom === 16){
        return "250 m"
    }
    if(zoom === 17){
        return "200 m"
    }
    if(zoom === 18){
        return "50 m"
    }
    if(zoom === 19){
        return "25 m"
    }
}

export  function refetch(self){
    self.map.entities.clear()
    self.Microsoft.Maps.loadModule("Microsoft.Maps.GeoJson", function () {
        self.Microsoft.Maps.loadModule("Microsoft.Maps.SpatialMath", function () {
            self.props.zones.forEach(function (e, zindex) {
                var p = self.Microsoft.Maps.GeoJson.read(e["polygon"], {
                    polygonOptions: {
                        fillColor: e.fillColor,
                        strokeColor: "#ffffff",
                        strokeThickness: 2
                    }
                });
                var area = self.Microsoft.Maps.SpatialMath.Geometry.area(p, self.Microsoft.Maps.SpatialMath.AreaUnits.Acres);
                area = Math.round(area * 100) / 100;
                const centroid = self.Microsoft.Maps.SpatialMath.Geometry.centroid(p)
                const deg = self.Microsoft.Maps.SpatialMath.toDegMinSec(centroid)
                const ob = self.convertDMStoObject(deg)
                const pushpin = new self.Microsoft.Maps.Pushpin(centroid, {
                    title: `Zone (${e.name})`,
                    subTitle: `${area} acre | ${ob["N"]} N  ${ob["E"]} E`,
                    color: e["strokeColor"]
                });
                self.map.entities.push(p);
                self.map.entities.push(pushpin)
                if (self.state.fab === "DELETE") {
                    self.Microsoft.Maps.Events.addHandler(p, "click", function (_) {
                        self.infobox = new self.Microsoft.Maps.Infobox(self.map.getCenter(), {
                            visible: false,
                            actions: [{
                                label: 'Delete Zone',
                                eventHandler: function (_) {
                                    self.map.entities.remove(p)
                                    self.map.entities.remove(pushpin)
                                    self.infobox.setOptions({ location: loc, title: "Edit Tools", visible: false });
                                    self.props.deleteZone(e["id"])
                                    refetch(self)
                                }
                            },
                            ]
                        });
                        self.infobox.setMap(self.map);
                        var loc = e.location;
                        self.infobox.setOptions({ location: loc, title: "Edit Tools", visible: true });
                    })
                }
                e.plots.forEach((plot, pindex) => {
                    var ps = self.Microsoft.Maps.GeoJson.read(plot["polygon"], {
                        polygonOptions: {
                            fillColor: plot.fillColor,
                            strokeColor: "#ffffff",
                            strokeThickness: 2
                        }
                    });
                    var area = self.Microsoft.Maps.SpatialMath.Geometry.area(ps, self.Microsoft.Maps.SpatialMath.AreaUnits.Acres);
                    area = Math.round(area * 100) / 100;
                    self.map.entities.push(ps);
                    const centroid = self.Microsoft.Maps.SpatialMath.Geometry.centroid(ps)
                    const deg = self.Microsoft.Maps.SpatialMath.toDegMinSec(centroid)
                    const ob = self.convertDMStoObject(deg)
                    const pushpin = new self.Microsoft.Maps.Pushpin(centroid, {
                        title: `Plot (${plot.name})`,
                        subTitle: `${area} acre | ${ob["N"]} N  ${ob["E"]} E`,
                        color: plot["strokeColor"]
                    });
                    self.map.entities.push(pushpin);
                    if (self.state.fab === "DELETE") {
                        self.Microsoft.Maps.Events.addHandler(ps, "click", function () {
                            self.infobox = new self.Microsoft.Maps.Infobox(self.map.getCenter(), {
                                visible: false,
                                actions: [{
                                    label: 'Delete Plot',
                                    eventHandler: function (_) {
                                        self.map.entities.remove(pushpin);
                                        self.map.entities.remove(ps);
                                        self.infobox.setOptions({ location: loc, title: "Edit Tools", visible: false });
                                        self.props.deletePlot(plot["id"], zindex)
                                        refetch(self);
                                }
                            },]
                        });
                        self.infobox.setMap(self.map);
                        var loc = e.location;
                        self.infobox.setOptions({ location: loc, title: "Edit Tools", visible: true });
                    })
                    }
                    plot.cropsland.forEach(c => {
                        var cp = self.Microsoft.Maps.GeoJson.read(c["polygon"], {
                            polygonOptions: {
                                fillColor: c["fillColor"],
                                strokeColor: c["strokeColor"],
                                strokeThickness: 2
                            }
                        });
                        var area = self.Microsoft.Maps.SpatialMath.Geometry.area(cp, self.Microsoft.Maps.SpatialMath.AreaUnits.Acres);
                        area = Math.round(area * 100) / 100;
                        const centroid = self.Microsoft.Maps.SpatialMath.Geometry.centroid(cp)
                        const deg = self.Microsoft.Maps.SpatialMath.toDegMinSec(centroid)
                        const ob = self.convertDMStoObject(deg)
                        const pushpin = new self.Microsoft.Maps.Pushpin(centroid, {
                            title: `Cropland (${c.name})`,
                            subTitle: `${area} acre | ${ob["N"]} N  ${ob["E"]} E`,
                            color: c["strokeColor"]
                        });
                        self.map.entities.push(cp);
                        self.map.entities.push(pushpin);
                        if (self.state.fab === "DELETE") {
                            self.Microsoft.Maps.Events.addHandler(cp, "click", function () {
                                self.infobox = new self.Microsoft.Maps.Infobox(self.map.getCenter(), {
                                    visible: false,
                                    actions: [{
                                        label: 'Delete Cropland',
                                        eventHandler: function (_) {
                                            self.map.entities.remove(pushpin);
                                            self.map.entities.remove(cp);
                                            self.props.deleteCropland(c["id"], zindex, pindex)
                                            refetch(self);
                                            self.infobox.setOptions({ location: loc, title: "Edit Tools", visible: false });
                                        }
                                    },]

                                });
                                self.infobox.setMap(self.map);
                                var loc = e.location;
                                self.infobox.setOptions({ location: loc, title: "Edit Tools", visible: true });
                            })
                        }
                    })
                })
            })
        }
        )
    })
}

export  function pan(dir){
    var dx = 0, dy = 0;
    switch (dir) {
        case 'up':
            dy = 30;
            break;
        case 'down':
            dy = -30;
            break;
        case 'left':
            dx = 30;
            break;
        case 'right':
            dx = -30;
            break;
        default:
            return    
     }
     if(this.map){
        this.map.setView({ center: this.map.getCenter(), centerOffset: new this.Microsoft.Maps.Point(dx, dy) });
     }
}

function loadBingApi(self,key) {
    const callbackName = "bingAPIReady";
    let url = `https://www.bing.com/api/maps/mapcontrol?callback=${callbackName}`;
    if (key) {
        url += `&key=${key}`;
    }
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        window[callbackName] = () => {
            self.Microsoft = window.Microsoft;
            resolve();
        };
        script.onerror = (error) => {
            reject(error);
        };
        document.body.appendChild(script);
    });
}
export function loadBing(self){
    loadBingApi(self,"AmcA8K-BLREvj-eIWtLS4tpk80zCUTl-8ZEw_wzktsINT2UY7WAsFYnpsYAnmlVX").then(_ => {
        self.map = new self.Microsoft.Maps.Map(document.getElementById("map"),{
            disableZooming: true, //disable zooming function
            showCopyright: false,
            showScalebar:false, 
            disableStreetside: true,
        });
        function dms(){
            self.Microsoft.Maps.loadModule("Microsoft.Maps.SpatialMath", function () {
                 const center = self.map.getCenter();
                 const deg = self.Microsoft.Maps.SpatialMath.toDegMinSec(center)
                 self.setState({
                    dmsString:deg
                 })
            })    
        }
        self.Microsoft.Maps.Events.addHandler(self.map, 'viewchangeend', dms);
        self.map.setView({
            mapTypeId: self.Microsoft.Maps.MapTypeId.aerial,
            zoom: 17
        });
        self.Microsoft.Maps.loadModule('Microsoft.Maps.DrawingTools', function () {
            var tools = new self.Microsoft.Maps.DrawingTools(self.map);
            self.tools = tools;
            const fill = ["rgba(51,0,255,0.2)", "rgba(255,0,0,0.2)", "rgba(255,255,0,0.2)", "rgba(0,204,0,0.2)"]
                        const stroke = ["#3300FF", "#FF0000", "#FFFF00", "#00CC00"]
            var da = self.Microsoft.Maps.DrawingTools.DrawingBarAction;
            tools.showDrawingManager(function (manager) {
                manager.setOptions({
                    drawingBarActions: da.polygon | da.erase,
                    fillColor: "rgba(255,255,255,0)",
                    strokeColor: "#ffffff",
                });
                self.manager = manager;
                self.Microsoft.Maps.Events.addHandler(manager, 'drawingEnded', function (e) {
                    if (e.geometry.boundingBox && e.geometry.bounds) {
                        const index = Math.round(Math.random() * 3)
                        if(self.state.fab !== "DELETE" && self.state.fab !== ""){
                            self.setState({
                                polygon:  e.geometry,
                                color: stroke[index],
                                fillColor: fill[index],
                                showModal: true,
                            })
                        }
                    }
                });
            })
        })
        refetch(self)
    })
}
export function zoomOut(self){
    const decrease = self.map.getZoom() - 1
       if(decrease <=19){    
        const eye = getEye(decrease)
        self.map.setView({ 
            zoom: decrease,
        });
        self.setState({
            eye:eye
         })
    }
}
export function zoomIn(self){
    const increase = self.map.getZoom() + 1
    if(increase <=19){
        const eye = getEye(increase)
        self.map.setView({
            zoom: increase,
        });
        self.setState({
            eye:eye
         })
    }
}

